import type { Entry } from 'contentful'

import { Link } from '@cbhq/cdx-components'

import { mapEntryLink } from '../globals/navlink'
import type { CDXGlobalNavLinkFields } from '../globals/navlink'

export function GlobalNavLink(linkProps: CDXGlobalNavLinkFields) {
  const { url, label } = mapEntryLink({
    fields: linkProps,
  } as Entry<CDXGlobalNavLinkFields>)

  return <Link href={url}>{label}</Link>
}
